<template>
    <div class="hot-question-content">
        <SatisfSceneList
            @sceneItemClick="sceneItemClick"
            :startDate="startDate"
            :endDate="endDate"
            :quesType="quesType"
            :channelType="channelType"
            :langType="langType"
            :order="order"
        />
        <div class="hot-question-table">
            <Table
                class="hot-question-list"
                :config="hotQuestionConfig"
                :dataset="hotQuesData"
                @pageChange="pageChange"
                @columnClick="tableColumnClick"
            />
            <div class="page-control">
                <PageControl :total="hotQuesTotal" :curPage="curPage" :pageLength="10" @pageClick="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import SatisfSceneList from "./SatisfSceneList";
import Table from "@/views/zhiji/bComponents/table/Table";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";

import { hotQuestionConfig } from "../satisfConfig.js";

export default {
    name: "QuesSatisfaction",
    props: ["startDate", "endDate", "quesType", "channelType", "langType", "order"],
    components: {
        SatisfSceneList,
        Table,
        PageControl
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            startTimeChange: this.startDate || this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00"),
            endTimeChange: this.endDate || this.zhiji.dateFormat(new Date()),
            quesTypeChange: "all",
            channelTypeChange: "all",
            hotQuesData: [],
            hotQuesTotal: 0,
            allHotNum: 0,
            sceneId: "",
            langTypeChange: "all",
            orderChange: "1"
        };
    },
    computed: {
        hotQuestionConfig() {
            return hotQuestionConfig();
        },
        numLable() {
            return this.$t("zhiji.hotSpot.numLable");
        }
    },
    watch: {
        order(newVal) {
            this.orderChange = newVal;
            this.getHotQuesData();
        },
        startDate(newVal) {
            this.startTimeChange = newVal;
            this.getHotQuesData();
        },
        endDate(newVal) {
            this.endTimeChange = newVal;
            this.getHotQuesData();
        },
        quesType(newVal) {
            this.quesTypeChange = newVal;
            this.getHotQuesData();
        },
        channelType(newVal) {
            this.channelTypeChange = newVal;
            this.getHotQuesData();
        },
        langType(newVal) {
            this.langTypeChange = newVal;
            this.getHotQuesData();
        }
    },
    mounted() {
        this.getHotQuesData();
    },
    methods: {
        getHotQuesData() {
            let reqData = {
                order: this.orderChange,
                startTime: this.startTimeChange,
                endTime: this.endTimeChange,
                quesType: this.quesTypeChange,
                channelType: this.channelTypeChange,
                langType: this.langTypeChange,
                curPageLen: this.curPageLen,
                page: this.curPage,
                sceneId: this.sceneId
            };
            this.zhiji.requestByServiceName("queryQuesSatisfyData", reqData).then(result => {
                this.hotQuesTotal = result.count;
                this.allHotNum = result.allQuesNum;
                this.hotQuesData.splice(0, this.hotQuesData.length, ...result.hotQuesData);

                if (!this.sceneId && !this.hotQuesTotal) {
                    this.$emit("noDataShow", true);
                } else {
                    this.$emit("noDataShow", false);
                }
            });
        },
        sceneItemClick(sceneId) {
            this.curPage = 1;
            this.sceneId = sceneId;
            this.$emit("sceneSelected", this.sceneId);
            this.getHotQuesData();
        },
        tableColumnClick(data) {
            if (data.colId === "question") {
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.rowId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "AnswerPanel",
                        hasRecommendSimilar: data.rowData.addData.recommendSimilar,
                        saveHandler: () => {
                            this.getHotQuesData();
                        }
                    }
                });
            }
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.getHotQuesData();
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-question-content {
    .hot-question-list {
        border: 1px solid #d8e4f0;
        border-top: none;
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
        border-style: solid;
        border-color: #d8e4f0;
        border-width: 0 1px 1px 1px;
    }

    .hot-question-num {
        margin-top: 12px;

        .total-question {
            color: #00c972;
        }
    }
}
</style>
